import * as Styled from './styled';
import { Outlet } from 'react-router-dom';
import { RightSide, LeftTracking } from './sections';
import { Props } from './types';
import Header from '../Header';
import { useLayout } from '~hooks';

function Layout({ withRightBanner, withLeftTracking, children }: Props) {
  const {
    header: { title, subtitle, position },
    container,
    disabledLayout,
  } = useLayout();

  return (
    <Styled.LayoutWrapper>
      {withLeftTracking && (
        <Styled.LeftSidebar>
          <LeftTracking />
        </Styled.LeftSidebar>
      )}
      <Styled.ContentContainer
        $hasBannerPadding={withRightBanner}
        $hasTrackingPadding={withLeftTracking}
        $paddingLeft={container?.paddingLeft}
        $paddingRight={container?.paddingRight}
        $disabledLayout={disabledLayout}
      >
        {!disabledLayout && (
          <Header title={title} subtitle={subtitle} logoPosition={position} />
        )}
        {children ? children : <Outlet />}
      </Styled.ContentContainer>
      {withRightBanner && <RightSide />}
    </Styled.LayoutWrapper>
  );
}

Layout.defaultProps = {
  withRightBanner: false,
};

export default Layout;
